import { PageHeader } from "@/components/app/PageHeader";
import { Card, CardContent } from "@/components/ui/card";
import { Typography } from "@/components/app/Typography";
import { FormField } from "@/components/app/FormField";
import { AppButton } from "@/components/app/AppButton";
import { Grid } from "@/components/app/Grid";
import { useState } from "react";
import { Input } from "@/components/app";

export default function NotificationManagementPage() {
  const [formData, setFormData] = useState({
    title: "",
    message: "",
    sentDate: "",
    sentTime: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    // API call would go here
    console.log("Submitting notification:", formData);
  };

  const handleClose = () => {
    setFormData({
      title: "",
      message: "",
      sentDate: "",
      sentTime: "",
    });
  };

  return (
    <div className="space-y-5">
      <PageHeader
        title="Notification Management"
        description="Lorem ipsum dolor sit amet consectetur. Nunc maecenas mi fermentum"
      />

      <Card className="border-border-light">
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <FormField label="Title" htmlFor="title">
                <Input
                  id="title"
                  size="lg"
                  placeholder="Enter Your Title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                />
              </FormField>
            </Grid>

            <Grid item xs={12}>
              <FormField label="Message" htmlFor="message">
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Enter Your Message"
                  className="w-full h-32 p-3 border border-border-light rounded-lg focus:outline-none focus:ring-2 focus:ring-primary resize-none"
                />
              </FormField>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormField label="Sent As" htmlFor="sentDate">
                <Input
                  id="sentDate"
                  size="lg"
                  type="date"
                  name="sentDate"
                  value={formData.sentDate}
                  onChange={handleChange}
                />
              </FormField>
            </Grid>

            <Grid item xs={12} md={6}>
              <FormField label="Sent Time" htmlFor="sentTime">
                <Input
                  id="sentTime"
                  size="lg"
                  type="time"
                  name="sentTime"
                  value={formData.sentTime}
                  onChange={handleChange}
                />
              </FormField>
            </Grid>
          </Grid>

          <div className="flex gap-3 justify-end mt-8">
            <AppButton
              variant="outlined"
              color="secondary"
              size="xl"
              fullWidth
              onClick={handleClose}
            >
              Close
            </AppButton>
            <AppButton
              variant="contained"
              color="primary"
              size="xl"
              fullWidth
              onClick={handleSubmit}
            >
              Submit
            </AppButton>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
